import { render } from "./RPagination.vue?vue&type=template&id=29e82db2&scoped=true"
import script from "./RPagination.vue?vue&type=script&lang=js"
export * from "./RPagination.vue?vue&type=script&lang=js"

import "./RPagination.vue?vue&type=style&index=0&id=29e82db2&lang=less&scoped=true"
import "./RPagination.vue?vue&type=style&index=1&id=29e82db2&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e82db2"]])

export default __exports__